import { externalActionCreators as dueDiligenceActions } from '@app/components/DueDiligenceItemEdit/modules/dueDiligenceItemEdit'
import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import { DevelopmentSiteViewPage } from '../components/DevelopmentSiteViewPage'
import {
  actionCreators,
  IDevelopmentSiteViewState,
  selectCityProfile,
  selectCriticalDatesDoc,
  selectDueDiligenceItems,
  selectError,
  selectIsDeleting,
  selectIsLoading,
  selectIsLoadingCityProfile,
  selectIsLoadingCriticalDatesDoc,
  selectIsLoadingDueDiligenceItems,
  selectIsSharingCriticalDates,
  selectPermissions,
  selectShowConfirmDelete,
  selectShowShareCriticalDatesModal,
  selectSite,
} from '../modules/developmentSiteView'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IDevelopmentSiteViewState & ICurrentUserState
    >({
      cityProfile: selectCityProfile(),
      criticalDatesDoc: selectCriticalDatesDoc(),
      dueDiligenceItems: selectDueDiligenceItems(),
      error: selectError(),
      isDeleting: selectIsDeleting(),
      isLoading: selectIsLoading(),
      isLoadingCityProfile: selectIsLoadingCityProfile(),
      isLoadingCriticalDatesDoc: selectIsLoadingCriticalDatesDoc(),
      isLoadingDueDiligenceItems: selectIsLoadingDueDiligenceItems(),
      isSharingCriticalDates: selectIsSharingCriticalDates(),
      permissions: selectPermissions(),
      showConfirmDelete: selectShowConfirmDelete(),
      showShareCriticalDatesModal: selectShowShareCriticalDatesModal(),
      site: selectSite(),
      user: selectCurrentUser(),
    }),
    { ...actionCreators, ...dueDiligenceActions },
  )(DevelopmentSiteViewPage),
)
